import React from "react";

export const AvgPMIcon: React.FC = () => {
  return (
    <svg
      width="70px"
      height="70px"
      viewBox="0 0 70 70"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <desc>Created with Sketch.</desc>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="CareGEM-Patient-MyHealthStatus-MyCurrentStatus-MyBloodPressure-V1.1-O2"
          transform="translate(-823.000000, -172.000000)"
        >
          <g id="Group-3-Copy-14" transform="translate(799.000000, 148.000000)">
            <g
              id="average-pm-bp-icon"
              transform="translate(24.000000, 24.000000)"
            >
              <path
                d="M35,-2.72848411e-12 L35,-2.72848411e-12 C54.3299662,-2.73203496e-12 70,15.6700338 70,35 L70,35 C70,54.3299662 54.3299662,70 35,70 L35,70 C15.6700338,70 2.36723813e-15,54.3299662 0,35 L0,35 C-2.36723813e-15,15.6700338 15.6700338,-2.72493325e-12 35,-2.72848411e-12 Z"
                id="Rectangle-Copy-204"
                fill="#EBF3FB"
              ></path>
              <g id="Group-8" transform="translate(10.000000, 9.000000)">
                <polygon
                  id="Path-32"
                  fillOpacity="0.679489357"
                  fill="#596174"
                  points="13.8171141 30.167095 7.30240754 29.8185714 1.76450985 24.9854935 0.806760619 18.6507576 2.60419491 15 5.69715842 13 7.31193738 13 9.98029344 9 12.5014664 7.90560526 15.877678 9 18.9732887 3.92318973 23.2405406 1.65508708 28.661433 1.65508708 33.6598357 3.92318973 36.7490932 7.90560526 38.1912761 13.9454 42.174221 15 45.9580982 18.8584422 45.9580982 24 43.8043536 28.3992857 39.3020322 30.167095"
                ></polygon>
                <path
                  d="M38.7070312,13.3242188 C41.0976682,13.3242188 43.1191324,14.1679603 44.7714844,15.8554688 C46.4238364,17.5429772 47.25,19.6171752 47.25,22.078125 C47.25,24.468762 46.4062584,26.54296 44.71875,28.3007812 C43.0312416,30.0586025 40.9921995,30.9375 38.6015625,30.9375 L9.4921875,30.9375 C6.89061199,30.9375 4.65821244,29.9882907 2.79492188,28.0898438 C0.931631309,26.1913968 0,23.9062634 0,21.234375 C0,19.1953023 0.597650273,17.3847735 1.79296875,15.8027344 C2.98828723,14.2206952 4.53514676,13.1132844 6.43359375,12.4804688 C6.71484516,10.933586 7.43554107,9.63281777 8.59570312,8.578125 C9.75586518,7.52343223 11.1093673,6.99609375 12.65625,6.99609375 C13.6406299,6.99609375 14.5546833,7.20702914 15.3984375,7.62890625 C16.4531303,5.5195207 17.9648339,3.81445963 19.9335938,2.51367188 C21.9023536,1.21288412 24.0820193,0.5625 26.4726562,0.5625 C29.8476731,0.5625 32.7480347,1.7753785 35.1738281,4.20117188 C37.5996215,6.62696525 38.8125,9.52732687 38.8125,12.9023438 C38.8125,12.9726566 38.7949221,13.0429684 38.7597656,13.1132812 C38.7246092,13.1835941 38.7070312,13.2539059 38.7070312,13.3242188 Z M38.6015625,29.25 C40.5000095,29.25 42.1347588,28.5293041 43.5058594,27.0878906 C44.87696,25.6464772 45.5625,23.9414161 45.5625,21.9726562 C45.5625,20.0038964 44.8945379,18.3339912 43.5585938,16.9628906 C42.2226496,15.59179 40.5703223,14.90625 38.6015625,14.90625 L37.0195312,14.90625 L37.0195312,12.6914062 C37.0195312,9.73826648 35.9824322,7.25977564 33.9082031,5.25585938 C31.833974,3.25194311 29.3203273,2.25 26.3671875,2.25 C24.3984277,2.25 22.552743,2.81249437 20.8300781,3.9375 C19.1074133,5.06250563 17.7890671,6.53905336 16.875,8.3671875 L16.2421875,9.84375 L14.765625,9.10546875 C14.0624965,8.75390449 13.3593785,8.578125 12.65625,8.578125 C11.5312444,8.578125 10.5293013,8.96483988 9.65039062,9.73828125 C8.77147998,10.5117226 8.22656355,11.4960878 8.015625,12.6914062 L7.91015625,13.640625 L6.9609375,13.9570312 C5.34374191,14.5195341 4.06055162,15.4511654 3.11132812,16.7519531 C2.16210463,18.0527409 1.6875,19.5468666 1.6875,21.234375 C1.6875,23.4140734 2.44335182,25.294914 3.95507812,26.8769531 C5.46680443,28.4589923 7.3124891,29.25 9.4921875,29.25 L38.6015625,29.25 Z"
                  id="ion-ios-cloud-outline---Ionicons"
                  stroke="#212B40"
                  strokeWidth="0.3"
                  fill="#212B40"
                ></path>
                <path
                  d="M28.5855511,50 C34.4684354,50 39.6766307,47.1253666 42.8690766,42.7106363 C38.8409757,42.7106363 28.8195026,43.3860979 24.1840792,35.6240426 C19.9432432,28.5227273 23.4270223,20.5681818 28.5855511,15 C18.8733194,15 11,22.8350169 11,32.5 C11,42.1649831 18.8733194,50 28.5855511,50 Z"
                  id="Oval-Copy"
                  stroke="#212B40"
                  strokeWidth="2"
                  fill="#FFFFFF"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
